import type { IxcPortfolioV1AssetBalanceKeys } from '@interxfi/types';
import { ixcPortfolioV1AssetBalanceStateEntity } from '../generated/entities/ixc-portfolio-v1-asset-balance-state';
import { buildIxcPortfolioV1PerformanceServicePerformanceKey } from '../generated/hooks/ixc-portfolio-v1-performance-service-performance';

export const ENTITY_EVENT_QUERY_INVALIDATION_SIDE_EFFECT_REGISTRY = {
  [ixcPortfolioV1AssetBalanceStateEntity.key]: (keys: IxcPortfolioV1AssetBalanceKeys) => [
    buildIxcPortfolioV1PerformanceServicePerformanceKey({ accountId: keys.accountId }),
  ],
} as const;
